import type { Asset } from "schemas/generated/asset";

import * as React from "react";

import { Spinner } from "@replo/design-system/components/spinner/Spinner";
import { ArrowUp } from "lucide-react";

import { AssetPreview } from "./AssetPreview";

const AssetCardLoader = () => {
  return (
    <div className="bg-default absolute left-1/2 top-1/2 flex h-8 w-8 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full">
      <Spinner size={28} variant="white" />
      <ArrowUp
        size={12}
        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-white"
      />
    </div>
  );
};

export const AssetThumbnail: React.FC<{
  asset: Asset;
  isUploading?: boolean;
}> = ({ asset, isUploading }) => {
  return (
    <div className="h-full overflow-hidden rounded-sm">
      <AssetPreview asset={asset} isUploading={isUploading} />
      {isUploading && <AssetCardLoader />}
    </div>
  );
};
